export enum AdditionalEventType {
  HOME_OFFICE_ENTRANCE = 1,
  HOME_OFFICE_EXIT = 2,
  ENTRY_EXIT_8_HOURS = 3,
  BUSINESS_ENTRY = 4,
  BUSINESS_EXIT = 5,
}
